import { render, staticRenderFns } from "./OrderLogs.vue?vue&type=template&id=47d47d26&scoped=true&"
import script from "./OrderLogs.vue?vue&type=script&lang=js&"
export * from "./OrderLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d47d26",
  null
  
)

export default component.exports